import { formatNumber } from 'src/utils/format';
import {
  DEFAULT_SUBSCRIPTION_STARTER_TIER,
  SUBSCRIPTION_PRO_TIER,
  SUBSCRIPTION_TIER,
  SUBSCRIPTION_PLAN,
} from './const';

export const clampSubscriptionTier = (tier, defaultValue = DEFAULT_SUBSCRIPTION_STARTER_TIER) => {
  const values = Object.values(SUBSCRIPTION_TIER);
  if (values.includes(tier)) {
    return tier;
  }
  return defaultValue;
};

const TIER_PROPS = {
  /* "tiered" plan tiers */
  [SUBSCRIPTION_TIER.tier_migrate]: {
    price: 0,
    wordsLimit: 6 * 1000,
  },
  [SUBSCRIPTION_TIER.tier_0]: {
    price: 0,
    wordsLimit: 5 * 1000,
  },
  [SUBSCRIPTION_TIER.tier_19]: {
    price: 19,
    wordsLimit: 15 * 1000,
    availableToUpgrade: true,
  },
  [SUBSCRIPTION_TIER.tier_39]: {
    price: 39,
    wordsLimit: 35 * 1000,
    availableToUpgrade: true,
  },
  [SUBSCRIPTION_TIER.tier_99]: {
    price: 99,
    wordsLimit: 100 * 1000,
    availableToUpgrade: true,
  },
  [SUBSCRIPTION_TIER.tier_149]: {
    price: 149,
    wordsLimit: 165 * 1000,
    availableToUpgrade: true,
  },
  [SUBSCRIPTION_TIER.tier_199]: {
    price: 199,
    wordsLimit: 240 * 1000,
    availableToUpgrade: true,
  },

  /* "pro" plans tiers */
  [SUBSCRIPTION_TIER.pro_beta_agency_tier_2]: {
    price: 750,
    priceAnnuallyPerMonth: 500,
    priceAnnually: 6000,
  },
  [SUBSCRIPTION_TIER.pro_beta_ecommerce_tier_1]: {
    price: 399,
    priceAnnuallyPerMonth: 266,
    priceAnnually: 3192,
    views: 1000000,
  },
  [SUBSCRIPTION_TIER.pro_beta_ecommerce_tier_2]: {
    price: 750,
    priceAnnuallyPerMonth: 500,
    priceAnnually: 6000,
    views: 5000000,
  },
  [SUBSCRIPTION_TIER.pro_beta_publisher_tier_1]: {
    price: 499,
    priceAnnuallyPerMonth: 333,
    priceAnnually: 3992,
  },
  [SUBSCRIPTION_TIER.pro_beta_publisher_tier_2]: {
    price: 750,
    priceAnnuallyPerMonth: 500,
    priceAnnually: 6000,
  },

  /* DEPRECATED "basic_tiered" plan tiers */
  [SUBSCRIPTION_TIER.basic_tier_15k]: {
    price: 19,
    priceAnnually: 190,
    priceAnnuallyPerMonth: 16,
    wordsLimit: 15 * 1000,
    availableToUpgrade: true,
    percentOfAnnualDiscount: 17,
  },
  [SUBSCRIPTION_TIER.basic_tier_30k]: {
    price: 29,
    priceAnnually: 290,
    priceAnnuallyPerMonth: 25,
    wordsLimit: 30 * 1000,
    availableToUpgrade: true,
    percentOfAnnualDiscount: 17,
  },
  [SUBSCRIPTION_TIER.basic_tier_50k]: {
    price: 39,
    priceAnnually: 390,
    priceAnnuallyPerMonth: 33,
    wordsLimit: 50 * 1000,
    availableToUpgrade: true,
    percentOfAnnualDiscount: 17,
  },

  /* "basic_tiered" plan tiers */
  [SUBSCRIPTION_TIER.basic_tier_20k]: {
    price: 29,
    priceAnnually: 290,
    priceAnnuallyPerMonth: 24,
    wordsLimit: 20 * 1000,
    availableToUpgrade: true,
    percentOfAnnualDiscount: 17,
    plan: SUBSCRIPTION_PLAN.basicTiered,
  },
  [SUBSCRIPTION_TIER.basic_tier_35k]: {
    price: 49,
    priceAnnually: 490,
    priceAnnuallyPerMonth: 41,
    wordsLimit: 35 * 1000,
    availableToUpgrade: true,
    percentOfAnnualDiscount: 17,
    plan: SUBSCRIPTION_PLAN.basicTiered,
  },
  [SUBSCRIPTION_TIER.basic_tier_65k]: {
    price: 59,
    priceAnnually: 590,
    priceAnnuallyPerMonth: 49,
    wordsLimit: 65 * 1000,
    availableToUpgrade: true,
    percentOfAnnualDiscount: 17,
    plan: SUBSCRIPTION_PLAN.basicTiered,
  },
  [SUBSCRIPTION_TIER.basic_tier_100k]: {
    price: 79,
    priceAnnually: 790,
    priceAnnuallyPerMonth: 66,
    wordsLimit: 100 * 1000,
    availableToUpgrade: true,
    percentOfAnnualDiscount: 17,
    plan: SUBSCRIPTION_PLAN.basicTiered,
  },
  [SUBSCRIPTION_TIER.basic_tier_200k]: {
    price: 149,
    priceAnnually: 1490,
    priceAnnuallyPerMonth: 124,
    wordsLimit: 200 * 1000,
    availableToUpgrade: true,
    percentOfAnnualDiscount: 17,
    plan: SUBSCRIPTION_PLAN.basicTiered,
  },
  [SUBSCRIPTION_TIER.basic_tier_300k]: {
    price: 199,
    priceAnnually: 1990,
    priceAnnuallyPerMonth: 166,
    wordsLimit: 300 * 1000,
    availableToUpgrade: true,
    percentOfAnnualDiscount: 17,
    plan: SUBSCRIPTION_PLAN.basicTiered,
  },

  /* "data_driven" plan tiers */
  [SUBSCRIPTION_TIER.data_driven_30k]: {
    price: 99,
    priceAnnually: 990,
    priceAnnuallyPerMonth: 83,
    wordsLimit: 30 * 1000,
    availableToUpgrade: true,
    percentOfAnnualDiscount: 17,
    plan: SUBSCRIPTION_PLAN.dataDriven,
  },
  [SUBSCRIPTION_TIER.data_driven_60k]: {
    price: 149,
    priceAnnually: 1490,
    priceAnnuallyPerMonth: 124,
    wordsLimit: 60 * 1000,
    availableToUpgrade: true,
    percentOfAnnualDiscount: 17,
    plan: SUBSCRIPTION_PLAN.dataDriven,
  },
  [SUBSCRIPTION_TIER.data_driven_100k]: {
    price: 179,
    priceAnnually: 1790,
    priceAnnuallyPerMonth: 149,
    wordsLimit: 100 * 1000,
    availableToUpgrade: true,
    percentOfAnnualDiscount: 17,
    plan: SUBSCRIPTION_PLAN.dataDriven,
  },
  [SUBSCRIPTION_TIER.data_driven_200k]: {
    price: 249,
    priceAnnually: 2490,
    priceAnnuallyPerMonth: 208,
    wordsLimit: 200 * 1000,
    availableToUpgrade: true,
    percentOfAnnualDiscount: 17,
    plan: SUBSCRIPTION_PLAN.dataDriven,
  },
  [SUBSCRIPTION_TIER.data_driven_300k]: {
    price: 299,
    priceAnnually: 2990,
    priceAnnuallyPerMonth: 249,
    wordsLimit: 300 * 1000,
    availableToUpgrade: true,
    percentOfAnnualDiscount: 17,
    plan: SUBSCRIPTION_PLAN.dataDriven,
  },
  [SUBSCRIPTION_TIER.pro_beta_agency_tier_1]: {
    price: 399,
    priceAnnuallyPerMonth: 333,
    priceAnnually: 3990,
    wordsLimit: 'Unlimited',
    availableToUpgrade: true,
    percentOfAnnualDiscount: 17,
    plan: SUBSCRIPTION_PLAN.proAgency,
  },
  [SUBSCRIPTION_TIER.seats_3]: {
    price: 99,
    priceAnnuallyPerMonth: 588 / 12,
    priceAnnually: 588,
    wordsLimit: 'Unlimited',
    availableToUpgrade: true,
    percentOfAnnualDiscount: 50,
    plan: SUBSCRIPTION_PLAN.dd_teams,
    seats: 3,
  },
  [SUBSCRIPTION_TIER.seats_4]: {
    price: 158,
    priceAnnuallyPerMonth: 1536 / 12,
    priceAnnually: 1536,
    wordsLimit: 'Unlimited',
    availableToUpgrade: true,
    percentOfAnnualDiscount: 20,
    plan: SUBSCRIPTION_PLAN.dd_teams,
    seats: 4,
  },
  [SUBSCRIPTION_TIER.seats_5]: {
    price: 217,
    priceAnnuallyPerMonth: 2124 / 12,
    priceAnnually: 2124,
    wordsLimit: 'Unlimited',
    availableToUpgrade: true,
    percentOfAnnualDiscount: 20,
    plan: SUBSCRIPTION_PLAN.dd_teams,
    seats: 5,
  },
  [SUBSCRIPTION_TIER.seats_6]: {
    price: 276,
    priceAnnuallyPerMonth: 2712 / 12,
    priceAnnually: 2712,
    wordsLimit: 'Unlimited',
    availableToUpgrade: true,
    percentOfAnnualDiscount: 20,
    plan: SUBSCRIPTION_PLAN.dd_teams,
    seats: 6,
  },
  [SUBSCRIPTION_TIER.seats_7]: {
    price: 335,
    priceAnnuallyPerMonth: 3300 / 12,
    priceAnnually: 3300,
    wordsLimit: 'Unlimited',
    availableToUpgrade: true,
    percentOfAnnualDiscount: 20,
    plan: SUBSCRIPTION_PLAN.dd_teams,
    seats: 7,
  },
  [SUBSCRIPTION_TIER.seats_8]: {
    price: 394,
    priceAnnuallyPerMonth: 3888 / 12,
    priceAnnually: 3888,
    wordsLimit: 'Unlimited',
    availableToUpgrade: true,
    percentOfAnnualDiscount: 20,
    plan: SUBSCRIPTION_PLAN.dd_teams,
    seats: 8,
  },
  [SUBSCRIPTION_TIER.seats_9]: {
    price: 453,
    priceAnnuallyPerMonth: 4476 / 12,
    priceAnnually: 4476,
    wordsLimit: 'Unlimited',
    availableToUpgrade: true,
    percentOfAnnualDiscount: 20,
    plan: SUBSCRIPTION_PLAN.dd_teams,
    seats: 9,
  },
  [SUBSCRIPTION_TIER.seats_10]: {
    price: 512,
    priceAnnuallyPerMonth: 5064 / 12,
    priceAnnually: 5064,
    wordsLimit: 'Unlimited',
    availableToUpgrade: true,
    percentOfAnnualDiscount: 20,
    plan: SUBSCRIPTION_PLAN.dd_teams,
    seats: 10,
  },
};

const SEAT_TIER_HIERARCHY = [
  SUBSCRIPTION_TIER.seats_3,
  SUBSCRIPTION_TIER.seats_4,
  SUBSCRIPTION_TIER.seats_5,
  SUBSCRIPTION_TIER.seats_6,
  SUBSCRIPTION_TIER.seats_7,
  SUBSCRIPTION_TIER.seats_8,
  SUBSCRIPTION_TIER.seats_9,
  SUBSCRIPTION_TIER.seats_10,
];

export const MAX_SEAT_TIER = SUBSCRIPTION_TIER.seats_10;
export const MIN_SEAT_TIER = SUBSCRIPTION_TIER.seats_3;

// Check only prices with "annual" discount - they're always lower then monthly ones
export const MIN_PRO_TIER_PRICE = Object.values(SUBSCRIPTION_PRO_TIER)
  .map((tier) => TIER_PROPS[tier].priceAnnuallyPerMonth)
  .reduce((acc, price) => (price && price < acc ? price : acc), Number.MAX_VALUE);

export const MIN_ECOMMERCE_TIER_PRICE = Object.values(SUBSCRIPTION_PRO_TIER)
  .filter((tier) => tier.includes('ecommerce'))
  .map((tier) => TIER_PROPS[tier].price)
  .reduce((acc, price) => (price && price < acc ? price : acc), Number.MAX_VALUE);

export const getNextSeatTier = (tier) => {
  const tierIndex = SEAT_TIER_HIERARCHY.indexOf(tier);
  if (tierIndex !== -1 && tierIndex !== SEAT_TIER_HIERARCHY.length - 1) {
    return SEAT_TIER_HIERARCHY[tierIndex + 1];
  }
};

export const lessOrEqualSeatTier = (tierOne, tierTwo) => {
  const tierIndexOne = SEAT_TIER_HIERARCHY.indexOf(tierOne);
  const tierIndexTwo = SEAT_TIER_HIERARCHY.indexOf(tierTwo);
  if (tierIndexOne !== -1 && tierIndexTwo !== -1) {
    return tierIndexOne <= tierIndexTwo;
  }
};

export const getTierProperty = (tier, property, defaultValue = undefined) => {
  const props = TIER_PROPS[tier];
  return (props && props[property]) || defaultValue;
};

export const getSubscriptionTierPrice = (tier) => getTierProperty(tier, 'price', 0);

export const getSubscriptionTierWordsLimit = (tier) => getTierProperty(tier, 'wordsLimit', 0);

export const getSubscriptionTierWordsLimitFormatted = (tier) => {
  const subscriptionLimit = getSubscriptionTierWordsLimit(tier);

  return Number.isFinite(subscriptionLimit) ? formatNumber(subscriptionLimit) : subscriptionLimit;
};

export const getPlanByTier = (tier, defaultPlan) => {
  return getTierProperty(tier, 'plan', defaultPlan);
};

export const isSubscriptionTierAvailableToUpgrade = (tier) =>
  getTierProperty(tier, 'availableToUpgrade', false);

export const getSubscriptionTierViewsLimit = (tier) => {
  return getTierProperty(tier, 'views', 0);
};

export const getSubscriptionTierSeatsLimit = (tier) => getTierProperty(tier, 'seats', 1);

export const getSubscriptionTierTextFormatObject = (tier) => {
  if (!tier) return null;

  const wordsLimit = getSubscriptionTierWordsLimitFormatted(tier);
  const seatsLimit = getSubscriptionTierSeatsLimit(tier);

  return { wordsLimit, seatsLimit };
};
